module.exports = __webpack_public_path__ + "fonts/NHaasGroteskTXPro-55Rg.9bcbcaa.ttf";